exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.j-address-list-right-card-box .ant-table-placeholder {\n  min-height: 46px;\n}\n", ""]);

// exports
